<template>
  <form id="form-add-document" class="position-relative" @submit.prevent="submit">
    <loader :loading="loadingForm" block />

    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        Подписать документ
      </v-card-title>
      <div class="p-2" v-show="signServiceInited">
        <v-divider class="mt-4"></v-divider>
        <div>
          <div id="DataToSignDoctorSurName" :data-last-name="$store.state.auth.profile.surname"></div>
          <div
            id="DataToSignTxtBox"
            name="DataToSignTxtBox"
            style="height: 20px; width: 100%; resize: none; border: 0px; display: none;"
            v-html="customerForm.data_to_sign"
          ></div>
          <textarea
            id="SignatureTxtBox"
            readonly=""
            style="font-size:9pt;height:600px;width:100%;resize:none;border:0;display:none"
            ref="doctor_sign"
          ></textarea>
          <div v-if="sertError" class="sert-list text-danger">{{ sertError }}</div>
          <div class="sert-list">
            <div class="h3 mb-2">Выберите сертификат для подписания</div>
            <div id="boxdiv" style="display:none">
              <span id="errorarea" style="color: red;font-weight: 700;">
                У вас отсутствуют личные сертификаты.
              </span>
            </div>
            <select size="8" name="CertListBox" id="CertListBox" style="width:100%;resize:none;border:0;"></select>
          </div>
        </div>
      </div>

      <v-divider class="mt-4"></v-divider>

      <v-card-actions>
        <v-btn id="form-add-document-close" type="button" color="primary" text @click="close">
          Закрыть
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="customerForm" id="form-add-document-show-sign" type="button" color="primary" text @click="sign()">
          Подписать
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Loader from "@/components/Loader.vue";
import { formModal } from "@/mixins/modal/form-modal.js";
import { API_ERROR_MESSAGE } from "@/config.js";
import asFormData from "json-form-data";

export default {
  name: "SignDocument",

  components: { Loader },

  mixins: [formModal],

  props: {
    date: {
      type: String,
      default: "",
    },

    customerForm: {
      //type: Object,
      default: null,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      signed: false,
      sertError: "",
      signServiceInited: false,
      showSertList: false,

      formTitle: "Добавить документ",
      loadingForm: false,
      loadingShowModeForm: false,

      loadingTypes: false,
      eventsTypes: [],
      formFields: [],
      formSchema: [],
      formDynamicValidation: {
        category: { required },
      },

      form: {
        author: "",
        category: "",
        files_to_remove: [],
        name: "",
        real_date: "",
      },

      filesToPreview: [],
    };
  },

  validations() {
    return {
      form: this.formDynamicValidation,
    };
  },

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },

  async created() {
    await this.loadData();
  },
  mounted() {
    this.$nextTick(() => {
      this.initSign();
    });
  },
  methods: {
    initSign() {
      if (!this.signServiceInited) {
        // var txtDataToSign = "Hello World";
        // document.getElementById("DataToSignTxtBox").innerHTML = txtDataToSign;
        document.getElementById("SignatureTxtBox").innerHTML = "";
        var canPromise = !!window.Promise;
        if (window.isEdge()) {
          window.ShowEdgeNotSupported();
        } else {
          if (canPromise) {
            window.cadesplugin.then(
              function() {
                window.Common_CheckForPlugIn();
              },
              error => {
                this.sertError = error;
              },
            );
          } else {
            window.addEventListener(
              "message",
              function(event) {
                if (event.data == "cadesplugin_loaded") {
                  window.CheckForPlugIn_NPAPI();
                } else if (event.data == "cadesplugin_load_error") {
                  this.sertError = "Плагин не загружен";
                }
              },
              false,
            );
            window.postMessage("cadesplugin_echo_request", "*");
          }
          this.signServiceInited = true;
        }
      }
    },
    sign() {
      const config = { childList: true };

      // Колбэк-функция при срабатывании мутации
      const callback = async (_, observer) => {
        // тут шлем запрос
        try {
          const res = await this.$http.post(`v1/customers/${this.customerId}/documents/${this.customerForm.id}/sign`, {
            signed_data: this.customerForm.data_to_sign,
            doctor_sign: this.$refs.doctor_sign.innerHTML,
            certificate: window.sertificateInfo || {},
          });
          if (res.data.success) {
            this.signed = true;
            this.showSertList = false;
            // потом удаляем обзервер
            observer.disconnect();
            const form = {
              ...this.form,
              author: this.$store.state.auth.id,
            };
            await this.update(form);
            window.location.reload();
          } else {
            this.sertError = res.data.message;
          }
        } catch (e) {
          this.sertError = e.response.message;
        }
      };

      // Создаём экземпляр наблюдателя с указанной функцией колбэка
      const observer = new MutationObserver(callback);

      // Начинаем наблюдение за настроенными изменениями целевого элемента
      observer.observe(this.$refs.doctor_sign, config);

      window.Common_SignCadesBES("CertListBox");
    },
    async update(form) {
      try {
        const response = await this.$http.post(
          `v1/customers/${this.$store.state.customer.id}/documents/${this.customerForm.id}`,
          asFormData(form),
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response.data.success) {
          this.$dialog.notify.success(response.data.message);

          this.$emit("close");
          this.$emit("submit", true);
        }
      } catch (e) {
        this.$dialog.notify.error(e.response.message || API_ERROR_MESSAGE);
      }
    },
    async loadData() {
      this.loading(true);

      try {
        const response = await this.$http.get(`v1/documents/types`, { params: { lang: "ru" } });
        this.eventsTypes = response.data.success ? response.data.data : [];
      } catch (e) {
        this.$dialog.notify.error(e.response.message || API_ERROR_MESSAGE);
      }
      this.loading(false);
    },
  },
};
</script>

<style scoped lang="scss">
.attachment-remove-file {
  position: absolute;
  padding-top: 0;
  margin-top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
<style lang="scss">
.sert-list {
  padding: 10px 20px;
}
#CertListBox {
  display: block;
  outline: none;
  overflow: hidden;
  line-height: 22px;
  font-size: 16px;
  option {
    height: 32px;
    line-height: 32px !important;
    display: flex;
    align-items: center;
    padding: 0 5px;
    &:hover {
      background: #e0e0e0 !important;
      cursor: pointer;
    }
    &:checked,
    &:active,
    &:focus {
      background: #ccc !important;
    }
  }
}
</style>
